// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__G9bV9","header":"MergedInvoice_header__1qu_2"};